export default "__VITE_ASSET__901dca73__"